(function() {
  var backdrop, modalImg, captionEl, productCard;

  function buildModal() {
    if (document.getElementById('ch-aso-backdrop')) return;
    var el = document.createElement('div');
    el.id = 'ch-aso-backdrop';
    el.innerHTML = [
      '<div class="ch-aso-modal">',
        '<button class="ch-aso-close" type="button" aria-label="Close">&#x2715;</button>',
        '<div class="ch-aso-img-wrap">',
          '<img id="ch-aso-img" src="" alt="">',
          '<div class="ch-aso-overlay">',
            '<p class="ch-aso-caption" id="ch-aso-caption"></p>',
          '</div>',
        '</div>',
        '<div class="ch-aso-product" id="ch-aso-product" style="display:none">',
          '<a class="ch-aso-product-inner" id="ch-aso-product-link" href="#">',
            '<img class="ch-aso-product-img" id="ch-aso-product-img" src="" alt="">',
            '<span class="ch-aso-product-title" id="ch-aso-product-title"></span>',
            '<span class="ch-aso-product-arrow">&#8250;</span>',
          '</a>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(el);
    backdrop = el;
    modalImg = document.getElementById('ch-aso-img');
    captionEl = document.getElementById('ch-aso-caption');
    productCard = document.getElementById('ch-aso-product');
    el.querySelector('.ch-aso-close').addEventListener('click', closeModal);
    el.addEventListener('click', function(e) {
      if (e.target === el) closeModal();
    });
  }

  function openModal(src, cap, prodTitle, prodUrl, prodImg) {
    buildModal();
    modalImg.src = src;
    captionEl.textContent = cap || '';

    if (prodTitle && prodUrl) {
      document.getElementById('ch-aso-product-link').href = prodUrl;
      document.getElementById('ch-aso-product-title').textContent = prodTitle;
      var pImg = document.getElementById('ch-aso-product-img');
      if (prodImg) {
        pImg.src = prodImg;
        pImg.style.display = 'block';
      } else {
        pImg.style.display = 'none';
      }
      productCard.style.display = 'block';
    } else {
      productCard.style.display = 'none';
    }

    backdrop.classList.add('ch-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!backdrop) return;
    backdrop.classList.remove('ch-open');
    document.body.style.overflow = '';
    modalImg.src = '';
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function getBigSrc(item) {
    var img = item.querySelector('img');
    if (!img) return '';
    var srcset = img.getAttribute('srcset') || '';
    if (srcset) {
      var parts = srcset.split(',');
      var last = parts[parts.length - 1].trim().split(' ')[0];
      if (last) return last;
    }
    return img.src.replace(/_(\d+x\d+|x\d+|\d+x)(\.jpg|\.jpeg|\.png|\.webp)/i, '_1200x1600$2');
  }

  function initCircles() {
    var wrap = document.querySelector('.yg-product-info-image-list-wrap');
    if (!wrap) return;
    var items = wrap.querySelectorAll('.yg-product-info-image-list-item');
    items.forEach(function(item) {
      item.style.cursor = 'pointer';
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.addEventListener('click', function() {
        openModal(
          getBigSrc(item),
          item.getAttribute('data-caption') || '',
          item.getAttribute('data-product-title') || '',
          item.getAttribute('data-product-url') || '',
          item.getAttribute('data-product-image') || ''
        );
      });
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          openModal(
            getBigSrc(item),
            item.getAttribute('data-caption') || '',
            item.getAttribute('data-product-title') || '',
            item.getAttribute('data-product-url') || '',
            item.getAttribute('data-product-image') || ''
          );
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCircles);
  } else {
    initCircles();
  }
})();
